import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from 'src/app/dashboard/services/dashboard/dashbaord.service';
declare var bootstrap: any;
@Component({
  selector: 'app-hero-text-with-img',
  templateUrl: './hero-text-with-img.component.html',
  styleUrls: ['./hero-text-with-img.component.css']
})
export class HeroTextWithImgComponent {
  @ViewChild('imageModalRef', { static: true }) imageModalRef!: ElementRef;
  selectedImage: string = '';
  @Input() data: any;
  record: any;

  constructor(private dashboardService: DashboardService, private router: Router) { }

  ngOnInit(): void {
    const lang = this.router.url.split('/')[1];
    this.dashboardService.getContent(lang || 'en').subscribe({
      next: (res: any) => {
        this.record = res.record;
      },
      error: () => {
        console.error('Failed to load data from dashboard service');
      }
    });
  }

  openImage(imagePath: string): void {
    this.selectedImage = imagePath;
    const modalEl = this.imageModalRef.nativeElement;
    const modal = new bootstrap.Modal(modalEl);
    modal.show();
  }

  get source() {
    return this.record || this.data;
  }
  openWhatsApp(): void {
    const phoneNumber = '201018519312';
    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, '_blank');
  }
}
